module.exports = __webpack_public_path__ + "static/logo-coa-575234e838d762023a715500d210c692.svg";